import React from 'react';
import api from '../api';
import { hinweis } from './Hinweise';

// Auswahl: Kalenderquartal oder freier Zeitraum.
// Wert: { jahr, quartal } oder { von, bis }

export const heuteIso = () => new Date().toLocaleDateString('sv-SE');

export function aktuellesQuartal() {
  const [y, m] = heuteIso().split('-').map(Number);
  return { jahr: y, quartal: Math.floor((m - 1) / 3) + 1 };
}

export function quartalGrenzen({ jahr, quartal }) {
  const von = `${jahr}-${String((quartal - 1) * 3 + 1).padStart(2, '0')}-01`;
  const ende = new Date(Date.UTC(jahr, quartal * 3, 0));
  return { von, bis: ende.toISOString().slice(0, 10) };
}

export const zeitraumText = (z) => (z?.quartal
  ? `Q${z.quartal} ${z.jahr}`
  : z?.von ? `${z.von.split('-').reverse().join('.')} – ${z.bis.split('-').reverse().join('.')}` : '');

export const fmtDatum = (iso) => (iso ? String(iso).slice(0, 10).split('-').reverse().join('.') : '–');
export const fmtZahl = (x) => Number(x || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtEuro = (x) => `${fmtZahl(x)} €`;

// Datei (z.B. Excel) mit Login herunterladen
export async function ladeDatei(pfad, params, dateiname) {
  try {
    const r = await api.get(pfad, { params, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = dateiname;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    let text = 'Download fehlgeschlagen';
    try { text = JSON.parse(await err.response.data.text()).error || text; } catch { /* Standardtext */ }
    hinweis.fehler(text);
  }
}

export default function ZeitraumWahl({ wert, onChange }) {
  const aktuell = aktuellesQuartal();
  const frei = !wert.quartal;
  const jahr = wert.quartal ? wert.jahr : Number((wert.von || heuteIso()).slice(0, 4));
  const jahre = [aktuell.jahr - 2, aktuell.jahr - 1, aktuell.jahr, aktuell.jahr + 1];

  const knopf = (aktiv) => ({
    padding: '0.35rem 0.75rem', borderRadius: 6, cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600,
    border: `1px solid ${aktiv ? 'var(--primary)' : 'var(--border)'}`,
    background: aktiv ? 'var(--primary)' : '#fff', color: aktiv ? '#fff' : 'var(--text)',
  });

  return (
    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
      <select className="form-control" style={{ width: 'auto', padding: '0.35rem 0.5rem' }} value={jahr} disabled={frei}
        onChange={e => onChange({ jahr: Number(e.target.value), quartal: wert.quartal || 1 })}>
        {jahre.map(j => <option key={j} value={j}>{j}</option>)}
      </select>
      {[1, 2, 3, 4].map(q => (
        <button key={q} type="button" style={knopf(!frei && wert.quartal === q)}
          onClick={() => onChange({ jahr, quartal: q })}>
          Q{q}{jahr === aktuell.jahr && q === aktuell.quartal ? ' (aktuell)' : ''}
        </button>
      ))}
      <button type="button" style={knopf(frei)}
        onClick={() => onChange(frei ? aktuell : { ...quartalGrenzen(aktuell) })}>
        Freier Zeitraum
      </button>
      {frei && (
        <>
          <input type="date" className="form-control" style={{ width: 'auto', padding: '0.3rem 0.5rem' }} value={wert.von}
            max={wert.bis} onChange={e => onChange({ von: e.target.value, bis: wert.bis })} />
          <span>bis</span>
          <input type="date" className="form-control" style={{ width: 'auto', padding: '0.3rem 0.5rem' }} value={wert.bis}
            min={wert.von} onChange={e => onChange({ von: wert.von, bis: e.target.value })} />
        </>
      )}
    </div>
  );
}
